<template>
  <div class="adauga-factura-intrare-vertical d-flex flex-column gap-4">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="fw-bold mb-0">Completeaza factură intrare</h5>
      <slot name="actions"></slot>
    </div>

    <div class="d-flex flex-column gap-3">
      <!-- Serie + număr + Furnizor (same row) -->
      <div class="row g-3 align-items-end">
        <!-- Serie + număr -->
        <!-- Serie + număr -->
        <div class="col-12 col-md-3">
          <label class="form-label mb-1">Serie și număr</label>
          <input v-model="smartSerieNr" @input="onSmartSerieNrInput" type="text" class="form-control"
            placeholder="Ex: F12345 (Serie + Număr)">
        </div>

        <!-- Tip Document -->
        <div class="col-12 col-md-3">
          <label class="form-label mb-1">Tip document</label>
          <multiselect v-model="tipDocObj" :options="tipuriDocument" track-by="id" label="descriere"
            placeholder="Selectează" class="w-100" :open-direction="'bottom'" :select-label="''" :deselect-label="''"
            :selected-label="''" />
        </div>

        <!-- Furnizor -->
        <div class="col-12 col-md-6">
          <label class="form-label mb-1">Furnizor</label>
          <div class="d-flex flex-wrap align-items-center gap-2">
            <div style="flex-grow: 1; min-width: 200px; max-width: 100%;">
              <multiselect id="id_furnizor" v-model="furnizorObj" :options="listaFurnizori"
                :custom-label="option => furnizorLabel(option)" track-by="id" placeholder="Selectează furnizorul"
                class="form-control furnizor-multiselect" :open-direction="'bottom'" :select-label="''"
                :deselect-label="''" :selected-label="''" :disabled="efactura_lock"
                @update:modelValue="val => onFurnizorSelected(val)">
                <template #singleLabel="{ option }">
                  <span :title="furnizorLabel(option)">{{ furnizorLabel(option) }}</span>
                </template>
                <template #noResult="{ search }">
                  <div class="text-center p-2">
                    <div class="text-muted mb-2">
                      Furnizorul "<strong>{{ search }}</strong>" nu există.
                    </div>
                    <button type="button" class="btn btn-sm btn-primary" @click="deschideFormAdaugareFurnizor(search)">
                      Adaugă furnizor
                    </button>
                  </div>
                </template>
              </multiselect>
            </div>
            <button class="btn btn-sm btn-light" type="button" @click="modalNomenclatorFurnizori"
              :disabled="efactura_lock">
              <i class="fas fa-list"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Date + Valută + Curs + Sold (same row) -->
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label mb-1">Data emiterii</label>
          <div class="position-relative">
            <input ref="dateEmitereRef" v-model="factura.data_emitere" type="date" class="form-control pe-5" />
            <button type="button" class="date-picker-btn btn btn-outline-secondary btn-sm"
              @click="openNativePicker('emitere')" aria-label="Deschide calendar">
              📅
            </button>
          </div>
        </div>

        <div class="col-12 col-md-3">
          <label class="form-label mb-1">Data scadenței</label>
          <div class="position-relative">
            <input ref="dateScadentaRef" v-model="factura.termen_plata" type="date" class="form-control pe-5"
              @input="termenPlataManual = true" />
            <button type="button" class="date-picker-btn btn btn-outline-secondary btn-sm"
              @click="openNativePicker('scadenta')" aria-label="Deschide calendar">
              📅
            </button>
          </div>
        </div>

        <div class="col-12 col-md-2">
          <label class="form-label mb-1">Valută</label>
          <multiselect v-model="valutaObj" :options="valute" :custom-label="valutaLabel" track-by="id"
            placeholder="Valută" class="w-100" :open-direction="'bottom'" :select-label="''" :deselect-label="''"
            :selected-label="''" />
        </div>

        <div class="col-12 col-md-2">
          <label class="form-label mb-1">Curs valutar</label>
          <input v-model="factura.curs_valutar" type="number" step="0.0001" class="form-control" placeholder="Curs BNR">
        </div>

        <div class="col-12 col-md-2">
          <label class="form-label mb-1">Sold furnizor</label>
          <input :value="formattedSold" type="text" class="form-control" disabled>
        </div>
      </div>

      <!-- Buton afișare detalii suplimentare -->
      <div class="mt-2">
        <button type="button" class="btn btn-sm btn-light btn-outline-secondary" @click="showMore = !showMore">
          {{ showMore ? 'Ascunde detalii' : 'Afișează mai mult' }}
        </button>
      </div>

      <template v-if="showMore">
        <!-- Delegat -->
        <div class="d-flex flex-column gap-2 mt-3">
          <div>
            <label class="form-label mb-1">Delegat</label>
            <input v-model="factura.delegat_nume" type="text" class="form-control" placeholder="Nume delegat">
          </div>
          <div>
            <label class="form-label mb-1">Date delegat</label>
            <input v-model="factura.delegat_date" type="text" class="form-control"
              placeholder="CNP / CI / alte detalii">
          </div>
          <div>
            <label class="form-label mb-1">Auto delegat</label>
            <input v-model="factura.delegat_auto" type="text" class="form-control" placeholder="Număr auto">
          </div>
        </div>

        <!-- Intocmit -->
        <div class="d-flex flex-column gap-2 mt-3">
          <div>
            <label class="form-label mb-1">Întocmit de</label>
            <input v-model="factura.intocmit_de" type="text" class="form-control" placeholder="Nume persoană">
          </div>
          <div>
            <label class="form-label mb-1">CNP întocmit</label>
            <input v-model="factura.intocmit_cnp" type="text" class="form-control" placeholder="CNP">
          </div>
        </div>

        <!-- Informatii suplimentare -->
        <div class="mt-3">
          <label class="form-label mb-1">Informații suplimentare</label>
          <textarea v-model="factura.informatii_suplimentare" rows="3" class="form-control"
            placeholder="Note, observații, condiții speciale..."></textarea>
        </div>
      </template>

      <!-- Produse -->
      <div class="mt-3">
        <label class="form-label mb-1">Produse</label>
        <div class="table-responsive">
          <table class="table table-sm align-middle mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Denumire</th>
                <th>Cant.</th>
                <th>UM</th>
                <th>Preț</th>
                <th>TVA %</th>
                <th>Valoare</th>
                <th>TVA</th>
                <th>Total</th>
                <th>Cont credit</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(p, idx) in produseLocal">
                <!-- VIEW ROW: compact summary when not editing -->
                <tr v-if="!p._editing" :key="`prod-view-${idx}`">
                  <td>{{ p.pozitie || idx + 1 }}</td>
                  <td>{{ p.denumire }}</td>
                  <td>{{ p.cantitate }}</td>
                  <td>{{ formatUm(p.um) }}</td>
                  <td>{{ p.pret }}</td>
                  <td>{{ p.cota_tva }}</td>
                  <td>{{ p.valoare }}</td>
                  <td>{{ p.valoare_tva }}</td>
                  <td>{{ p.total }}</td>
                  <td>{{ formatContCredit(p.cont_credit) }}</td>
                  <td class="text-end">
                    <button type="button" class="btn btn-xs btn-light-primary me-1" @click="editProdus(idx)">
                      Editează
                    </button>
                    <button type="button" class="btn btn-xs btn-light-danger" @click="removeProdus(idx)">
                      Șterge
                    </button>
                  </td>
                </tr>

                <!-- EDIT ROW: full form card when editing -->
                <tr v-else :key="`prod-edit-${idx}`">
                  <td colspan="11" class="p-0">
                    <div class="border rounded p-3 mb-2 d-flex flex-column gap-3 bg-light-subtle">

                      <!-- ROW 1: # linie + TIP (same row) -->
                      <div class="row g-3 align-items-end">
                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold"># linie</label>
                          <input v-model.number="p.pozitie" type="number" min="1" class="form-control form-control-lg">
                        </div>
                        <div class="col-6 col-md-9">
                          <label class="form-label mb-1 fw-bold">Tip</label>
                          <multiselect v-model="p.tip" :options="tipuriProduse" track-by="id" label="text"
                            placeholder="Alege tip" class="w-100" :open-direction="'bottom'" :select-label="''"
                            :deselect-label="''" :selected-label="''" />
                        </div>
                      </div>

                      <!-- ROW 2: DENUMIRE PRODUS -->
                      <div class="d-flex flex-column">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                          <span class="badge bg-secondary">
                            #{{ p.pozitie || idx + 1 }}
                          </span>
                        </div>
                        <label class="form-label mb-1 fw-bold">Denumire produs</label>
                        <input v-model="p.denumire" type="text" class="form-control form-control-lg"
                          placeholder="Denumirea completă a produsului / serviciului">
                      </div>

                      <!-- ROW 3: GRID WITH BIG FIELDS -->
                      <div class="row g-3">

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">Cantitate</label>
                          <input v-model.number="p.cantitate" type="number" min="0" step="0.01"
                            class="form-control form-control-lg" @input="onProdusChanged(p)">
                        </div>

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">UM</label>
                          <multiselect v-model="p.um" :options="unitatiMasura" track-by="id" label="text"
                            placeholder="Alege UM" class="w-100" :open-direction="'bottom'" :select-label="''"
                            :deselect-label="''" :selected-label="''" />
                        </div>

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">Preț unitar</label>
                          <input v-model.number="p.pret" type="number" min="0" step="0.0001"
                            class="form-control form-control-lg" @input="onProdusChanged(p)">
                        </div>

                        <div class="col-6 col-md-3">
                          <label class="form-label mb-1 fw-bold">TVA (%)</label>
                          <multiselect v-model="p.cota_tva_obj" :options="coteTva" :custom-label="tvaLabel"
                            track-by="id" placeholder="Alege TVA" class="w-100" :open-direction="'bottom'"
                            :select-label="''" :deselect-label="''" :selected-label="''"
                            @update:modelValue="val => onTvaSelected(p, val)" />
                        </div>

                        <div class="col-6 col-md-4">
                          <label class="form-label mb-1 fw-bold">Valoare</label>
                          <input v-model.number="p.valoare" type="number" min="0" step="0.01"
                            class="form-control form-control-lg" @input="onValoareChanged(p)">
                        </div>

                        <div class="col-6 col-md-4">
                          <label class="form-label mb-1 fw-bold">TVA</label>
                          <input v-model.number="p.valoare_tva" type="number" min="0" step="0.01"
                            class="form-control form-control-lg" readonly>
                        </div>

                        <div class="col-6 col-md-4">
                          <label class="form-label mb-1 fw-bold">Total</label>
                          <input v-model.number="p.total" type="number" min="0" step="0.01"
                            class="form-control form-control-lg fw-bold" @input="onTotalChanged(p)">
                        </div>

                        <div class="col-12 col-md-6">
                          <label class="form-label mb-1 fw-bold">Cont credit</label>
                          <multiselect v-model="p.cont_credit_obj" :options="effectivePlanConturi"
                            :custom-label="pcLabel" track-by="id" placeholder="Alege cont"
                            class="w-100 small-text-multiselect" :open-direction="'bottom'" :select-label="''"
                            :deselect-label="''" :selected-label="''"
                            @update:modelValue="val => onContCreditSelected(p, val)" />
                        </div>

                      </div>

                      <!-- ACTION BUTTONS -->
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <button type="button" class="btn btn-sm btn-light-danger" @click="removeProdus(idx)">
                          Șterge produs
                        </button>
                        <button type="button" class="btn btn-sm btn-primary" @click="saveProdus(idx)">
                          Salvează produs
                        </button>
                      </div>

                    </div>
                  </td>
                </tr>
              </template>
              <tr v-if="!produseLocal.length">
                <td colspan="11" class="text-muted small text-center py-3">
                  Niciun produs adăugat. Apasă „Adaugă produs”.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-2">
          <button type="button" class="btn btn-sm btn-light-primary fw-bold" @click="addProdus">
            + Adaugă produs
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'AdaugaFacturaIntrareVertical',
  components: { Multiselect },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    seriiFacturi: {
      type: Array,
      default: () => []
    },
    listaFurnizori: {
      type: Array,
      default: () => []
    },
    valute: {
      type: Array,
      default: () => []
    },
    unitatiMasura: {
      type: Array,
      default: () => []
    },
    tipuriProduse: {
      type: Array,
      default: () => []
    },
    planConturi: {
      type: Array,
      default: () => []
    },
    coteTva: {
      type: Array,
      default: () => []
    },
    produse: {
      type: Array,
      default: () => []
    },
    autoInit: {
      type: Boolean,
      default: true
    },
    initialNumar: {
      type: [String, Number],
      default: ''
    },
    soldFormatter: {
      type: Function,
      default: (val) => {
        if (val === null || val === undefined || val === '') return '';
        const n = Number(val) || 0;
        return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }
  },
  emits: ['update:modelValue', 'furnizor-selected', 'serie-selected', 'update:produse', 'open-nomenclator-furnizori', 'add-furnizor'],
  data() {
    return {
      showMore: false,
      termenPlataManual: false,
      smartSerieNr: '',

      id_tip_document: null,
      tipuriDocument: [], // Will fetch from API
      tipDocObj: null, // Initial selection
      localPlanConturi: [],   // Added for fallback
    };
  },
  mounted() {
    this.incarcaTipDocument();
    this.incarcaPlanConturi();
  },
  computed: {
    efactura_lock() {
      // Admin intrări: by default unlocked; parent can optionally set a boolean `efactura_lock` on factura.
      return Boolean(this.factura?.efactura_lock);
    },
    factura: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    serieObj: {
      get() {
        return (
          this.seriiFacturi.find(s =>
            s.id === this.factura.serie_document ||
            s.value === this.factura.serie_document ||
            s.serie === this.factura.serie_document
          ) || this.factura.serie_document_obj || null
        );
      },
      set(val) {
        this.factura.serie_document = val
          ? (val.id ?? val.value ?? val.serie ?? null)
          : null;
        this.factura.serie_document_obj = val || null;
        this.$emit('serie-selected', val);
      }
    },
    furnizorObj: {
      get() {
        const id = this.factura.id_furnizor || this.factura.client;
        let found = null;
        if (id && Array.isArray(this.listaFurnizori)) {
          found = this.listaFurnizori.find(c =>
            c.id === id || c.value === id || c.id_furnizor === id
          );
        }
        return found || this.factura.furnizor_obj || this.factura.client_obj || null;
      },
      set(val) {
        const id = val
          ? (val.id ?? val.value ?? val.id_furnizor ?? null)
          : null;
        this.factura.id_furnizor = id;
        // compatibilitate cu vechiul câmp, dacă există
        this.factura.client = id;
        this.factura.furnizor_obj = val || null;
        this.factura.client_obj = val || null;
        this.$emit('furnizor-selected', val);
      }
    },
    formattedSold() {
      return this.soldFormatter(this.factura.sold);
    },
    produseLocal: {
      get() {
        return this.produse;
      },
      set(val) {
        this.$emit('update:produse', val);
      }
    },
    valutaObj: {
      get() {
        return (
          this.valute.find(v =>
            v.id === this.factura.valuta ||
            v.value === this.factura.valuta ||
            v.scurt === this.factura.valuta ||
            v.text === this.factura.valuta
          ) || this.factura.valuta_obj || null
        );
      },
      set(val) {
        const id = val
          ? (val.id ?? val.value ?? val.scurt ?? val.text ?? null)
          : null;
        this.factura.valuta = id;
        this.factura.valuta_obj = val || null;

        // dacă valuta are curs, îl setăm automat
        if (val && typeof val.curs !== 'undefined' && val.curs !== null) {
          const n = Number(val.curs);
          if (!Number.isNaN(n)) {
            this.factura.curs_valutar = n;
          }
        }
      }
    },
    effectivePlanConturi() {
      return (this.planConturi && this.planConturi.length) ? this.planConturi : this.localPlanConturi;
    },
  },
  methods: {
    incarcaTipDocument() {
      // Load tipuri document from API (tip=1 for Intrarea)
      axios.get('/api/administrare/work/utils/tipuri-documente', { params: { tip: 1 } })
        .then(r => {
          this.tipuriDocument = r.data || [];
          // Set default to 'Factura'
          if (this.tipuriDocument.length > 0) {
            const def = this.tipuriDocument.find(t => t.descriere === 'Factura');
            this.tipDocObj = def || this.tipuriDocument[0];
          } else {
            this.tipDocObj = null;
          }
        })
        .catch(e => console.error(e));
    },
    async incarcaPlanConturi() {
      if (this.planConturi && this.planConturi.length > 0) return;
      const firmaId = this.factura?.id_firma || this.modelValue?.id_firma;
      if (!firmaId) return;

      try {
        // We emit an event to let parent know, OR update a local copy if we can't mutate prop.
        // Mutating prop is bad.
        // Check if we have a local data property for plan? No.
        // We use 'planConturi' prop in template.
        // If we want to support self-fetch, we should have a local data backup.

        // BUT: the component uses `planConturi` prop.
        // If I cannot mutate it, I should change usage in template to `computedPlanConturi`.

        // Let's do that: computed `effectivePlanConturi`.
        const res = await axios.get(`/api/administrare/work/utils/plan-conturi/${firmaId}`);
        this.localPlanConturi = res.data || [];
      } catch (e) { console.error('Err fetch plan conturi fallback', e); }
    },
    onFurnizorSelected(val) {
      // keep existing computed setter behavior + allow parent to recalc sold
      this.furnizorObj = val || null;
      this.incarcaSoldFurnizorSelected(val || null);
    },
    incarcaSoldFurnizorSelected(val) {
      // delegate to parent (admin container) to fetch/display supplier balance
      this.$emit('furnizor-selected', val);
    },
    modalNomenclatorFurnizori() {
      // parent should open the nomenclator modal
      this.$emit('open-nomenclator-furnizori');
    },
    deschideFormAdaugareFurnizor(search) {
      // parent should open add-supplier flow, optionally prefilled with search
      this.$emit('add-furnizor', search);
    },
    serieLabel(option) {
      if (!option) return '';
      return option.text || option.denumire || option.label || option.serie || String(option.id ?? option.value ?? '');
    },
    furnizorLabel(option) {
      if (!option) return '';
      return option.text || option.denumire || option.nume || option.label || String(option.id ?? option.value ?? '');
    },
    valutaLabel(option) {
      if (!option) return '';
      // ex: "EUR (4.97)"
      const base = option.text || option.scurt || option.label || String(option.id ?? option.value ?? '');
      if (option.curs !== undefined && option.curs !== null) {
        return `${base} (${option.curs})`;
      }
      return base;
    },
    tvaLabel(option) {
      if (!option) return '';
      const v = (option.cota_tva != null) ? option.cota_tva : (option.value ?? option.id ?? '');
      return String(v);
    },
    pcLabel(option) {
      if (!option) return '';
      const cod = option.cod_complet ?? option.cod ?? option.value ?? option.id ?? '';
      const den = option.descriere ?? option.denumire ?? option.text ?? option.label ?? '';
      return den ? `${cod} | ${den}` : String(cod);
    },
    onTvaSelected(p, val) {
      if (!p) return;
      p.cota_tva_obj = val || null;
      const t = val ? (val.cota_tva ?? val.value ?? val.id) : 0;
      p.cota_tva = (t != null && t !== '') ? Number(t) : 0;
      this.onProdusChanged(p);
    },
    onContCreditSelected(p, val) {
      if (!p) return;
      p.cont_credit_obj = val || null;
      const cod = val ? (val.cod_complet ?? val.cod ?? val.value ?? '') : null;
      p.cont_credit = cod || null;
    },
    hydrateProdusRefs(p) {
      if (!p) return;

      // TVA object from numeric
      if (!p.cota_tva_obj && Array.isArray(this.coteTva) && this.coteTva.length) {
        const t = (p.cota_tva != null && p.cota_tva !== '') ? Number(p.cota_tva) : null;
        if (t !== null && !Number.isNaN(t)) {
          p.cota_tva_obj = this.coteTva.find(x => Number(x.cota_tva) === t || Number(x.value) === t) || null;
        }
      }
      // If we have object but numeric missing, keep numeric in sync
      if (p.cota_tva_obj && (p.cota_tva == null || p.cota_tva === '')) {
        const t = p.cota_tva_obj.cota_tva ?? p.cota_tva_obj.value ?? p.cota_tva_obj.id;
        if (t != null) p.cota_tva = Number(t);
      }

      // Cont credit object from code
      if (!p.cont_credit_obj && p.cont_credit && Array.isArray(this.effectivePlanConturi) && this.effectivePlanConturi.length) {
        const cc = String(p.cont_credit);
        p.cont_credit_obj = this.effectivePlanConturi.find(x => String(x.cod_complet ?? x.cod ?? x.value ?? '') === cc) || null;
      }
      // If we have object but string missing, keep string in sync
      if (p.cont_credit_obj && !p.cont_credit) {
        p.cont_credit = p.cont_credit_obj.cod_complet ?? p.cont_credit_obj.cod ?? p.cont_credit_obj.value ?? null;
      }
    },
    hydrateAllProduseRefs() {
      if (!Array.isArray(this.produseLocal)) return;
      this.produseLocal.forEach(p => this.hydrateProdusRefs(p));
    },
    formatContCredit(cc) {
      if (!cc) return '';
      if (typeof cc === 'string') return cc;
      if (typeof cc === 'object') return cc.cod_complet || cc.cod || cc.value || cc.id || '';
      return String(cc);
    },
    // Updated helper to use effectivePlanConturi
    getContLabel(cod) {
      if (!this.effectivePlanConturi || !this.effectivePlanConturi.length) return cod;
      const found = this.effectivePlanConturi.find(x => x.cod_complet === cod || x.id === cod);
      return found ? this.pcLabel(found) : cod;
    },
    toNumber(val, fallback = 0) {
      const n = Number(val);
      return Number.isNaN(n) ? fallback : n;
    },
    recalcProdus(p) {
      if (!p) return;
      const cant = this.toNumber(p.cantitate, 0);
      const pret = this.toNumber(p.pret, 0);
      const cota = this.toNumber(p.cota_tva, 0);

      const valoare = cant * pret;
      const valoare_tva = valoare * cota / 100;
      const total = valoare + valoare_tva;

      p.valoare = Number.isFinite(valoare) ? Number(valoare.toFixed(2)) : 0;
      p.valoare_tva = Number.isFinite(valoare_tva) ? Number(valoare_tva.toFixed(2)) : 0;
      p.total = Number.isFinite(total) ? Number(total.toFixed(2)) : 0;
    },
    onProdusChanged(p) {
      this.recalcProdus(p);
    },
    onValoareChanged(p) {
      const val = this.toNumber(p.valoare, 0);
      const cant = this.toNumber(p.cantitate, 1);
      const cota = this.toNumber(p.cota_tva, 0);

      const pret = cant !== 0 ? val / cant : 0;
      const valoare_tva = val * cota / 100;
      const total = val + valoare_tva;

      p.pret = Number.isFinite(pret) ? Number(pret.toFixed(4)) : 0;
      p.valoare_tva = Number.isFinite(valoare_tva) ? Number(valoare_tva.toFixed(2)) : 0;
      p.total = Number.isFinite(total) ? Number(total.toFixed(2)) : 0;
    },
    initSmartSerie() {
      // Initializeaza inputul smart din serie + numar existente
      if (this.factura.serie_document || this.factura.nr_document) {
        if (this.factura.serie_document && this.factura.nr_document) {
          this.smartSerieNr = `${this.factura.serie_document} ${this.factura.nr_document}`;
        } else if (this.factura.serie_document) {
          this.smartSerieNr = this.factura.serie_document;
        } else {
          this.smartSerieNr = this.factura.nr_document;
        }
      } else {
        this.smartSerieNr = '';
      }
    },
    onSmartSerieNrInput() {
      // Parseaza inputul in serie si numar
      const val = this.smartSerieNr;
      if (!val) {
        this.factura.serie_document = '';
        this.factura.nr_document = '';
        return;
      }

      // Regex: Tot ce nu e cifra la sfarsit e serie, ultimele cifre sunt numarul
      const match = val.match(/^(.*?)(\d+)$/);
      if (match) {
        const s = match[1].trim();
        const n = match[2];
        this.factura.serie_document = s;
        this.factura.nr_document = n;
      } else {
        // Fallback: totul e serie? Sau totul e numar daca-s doar cifre?
        // Presupunem ca daca nu se potriveste (adica n-are cifre la final sau e gol), e doar serie text
        // Dar daca e doar "123", regexul /^(.*?)(\d+)$/ face match cu grp1='' si grp2='123', deci intra mai sus.
        // Deci aici ajungem doar daca stringul NU are cifre la final (ex "ABC").
        this.factura.serie_document = val;
        this.factura.nr_document = '';
      }
    },
    onTotalChanged(p) {
      const tot = this.toNumber(p.total, 0);
      const cant = this.toNumber(p.cantitate, 1);
      const cota = this.toNumber(p.cota_tva, 0);

      const valoare = tot / (1 + cota / 100);
      const pret = cant !== 0 ? valoare / cant : 0;
      const valoare_tva = tot - valoare;

      p.valoare = Number.isFinite(valoare) ? Number(valoare.toFixed(2)) : 0;
      p.pret = Number.isFinite(pret) ? Number(pret.toFixed(4)) : 0;
      p.valoare_tva = Number.isFinite(valoare_tva) ? Number(valoare_tva.toFixed(2)) : 0;
    },
    resolveDefaultTip() {
      // Prefer explicit "G" / "Articole Generale" option if present, otherwise fallback to first option
      const opts = Array.isArray(this.tipuriProduse) ? this.tipuriProduse : [];
      if (!opts.length) return 1;

      const byText = opts.find(o => {
        const t = String(o?.text ?? o?.label ?? o?.denumire ?? '').toLowerCase();
        return t.includes('articole generale') || t.startsWith('g');
      });
      if (byText) return byText;

      const byId1 = opts.find(o => Number(o?.id ?? o?.value) === 1);
      if (byId1) return byId1;

      return opts[0];
    },
    resolveDefaultUm() {
      const opts = Array.isArray(this.unitatiMasura) ? this.unitatiMasura : [];
      if (!opts.length) return 1;

      // Prefer id=1 if exists
      const byId1 = opts.find(o => Number(o?.id ?? o?.value) === 1);
      if (byId1) return byId1;

      // Fallback by text match "Bucata"
      const byText = opts.find(o => String(o?.text ?? o?.label ?? o?.denumire ?? '').toLowerCase().includes('buc'));
      if (byText) return byText;

      return opts[0];
    },
    addProdus() {
      const nextPoz = (this.produseLocal?.length || 0) + 1;
      const nou = {
        pozitie: nextPoz,
        denumire: '',
        tip: this.resolveDefaultTip(),
        cota_tva: 21,
        cota_tva_obj: null,
        um: this.resolveDefaultUm(),
        cantitate: 1,
        pret: 0,
        valoare: 0,
        valoare_tva: 0,
        total: 0,
        cont_credit: null,
        cont_credit_obj: null,
        _editing: true,
      };
      this.recalcProdus(nou);
      this.hydrateProdusRefs(nou);
      const arr = Array.isArray(this.produseLocal) ? [...this.produseLocal, nou] : [nou];
      this.produseLocal = arr;
    },
    removeProdus(idx) {
      if (!Array.isArray(this.produseLocal)) return;
      const arr = [...this.produseLocal];
      arr.splice(idx, 1);
      this.produseLocal = arr;
    },
    editProdus(idx) {
      if (!Array.isArray(this.produseLocal)) return;
      const arr = [...this.produseLocal];
      if (arr[idx]) {
        arr[idx]._editing = true;
        this.hydrateProdusRefs(arr[idx]);
        this.produseLocal = arr;
      }
    },
    async saveProdus(idx) {
      if (!Array.isArray(this.produseLocal)) return;
      const arr = [...this.produseLocal];
      if (arr[idx]) {
        // basic sanity: dacă nu are denumire, nu închidem formularul
        if (!arr[idx].denumire || String(arr[idx].denumire).trim() === '') {
          return;
        }

        // Verifica Cont Credit
        if (!arr[idx].cont_credit && !arr[idx].cont_credit_obj) {
          const result = await Swal.fire({
            title: 'Cont credit nesetat',
            text: 'Acest produs nu are Cont Credit setat. Salvați produsul?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, salvează',
            cancelButtonText: 'Nu, continuă editarea'
          });

          if (!result.isConfirmed) {
            return;
          }
        }

        arr[idx]._editing = false;
        this.hydrateProdusRefs(arr[idx]);
        this.produseLocal = arr;
      }
    },
    formatUm(um) {
      if (!um) return '';
      if (typeof um === 'string') return um;
      if (typeof um === 'object') {
        return um.text || um.scurt || um.label || String(um.id ?? um.value ?? '');
      }
      return String(um);
    },
    openNativePicker(which) {
      if (which === 'emitere' && this.$refs.dateEmitereRef) {
        this.$refs.dateEmitereRef.showPicker?.();
      }
      if (which === 'scadenta' && this.$refs.dateScadentaRef) {
        this.$refs.dateScadentaRef.showPicker?.();
      }
    },
  },
  mounted() {
    if (this.autoInit) {
      if (!this.factura.data_emitere) {
        const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
        this.factura.data_emitere = today;
      }

      if (!this.factura.termen_plata) {
        this.factura.termen_plata = this.factura.data_emitere;
      }

      // Auto-add one empty product line if none exist
      if (!this.produseLocal || !this.produseLocal.length) {
        this.addProdus();
      }

      if (this.valute.length && !this.factura.valuta) {
        const first = this.valute[0];
        this.valutaObj = first;
      }

      if (!this.factura.serie_document && this.seriiFacturi.length) {
        const last = this.seriiFacturi[this.seriiFacturi.length - 1];
        this.serieObj = last;
      }

      if (!this.factura.nr_document) {
        if (this.initialNumar) {
          this.factura.nr_document = String(this.initialNumar);
        } else if (this.factura.serie_document_obj && this.factura.serie_document_obj.last_nr) {
          const next = Number(this.factura.serie_document_obj.last_nr) + 1;
          if (!Number.isNaN(next)) {
            this.factura.nr_document = String(next);
          }
        }
      }
    }
    this.hydrateAllProduseRefs();

    this.incarcaTipDocument();
  },

  watch: {
    'factura.data_emitere'(newVal) {
      if (this.autoInit && !this.termenPlataManual) {
        this.factura.termen_plata = newVal;
      }
    },
    'factura.id': {
      handler() {
        this.initSmartSerie();
      },
      immediate: true
    },
    tipDocObj(val) {
      if (val) {
        this.factura.tip_document = val.descriere; // keep string for compatibility/display
        this.factura.id_tip_document = val.id;     // send new ID
      } else {
        this.factura.tip_document = 'Factura_intrare';
        this.factura.id_tip_document = null;
      }
    },
    seriiFacturi(newVal) {
      if (this.autoInit && newVal && newVal.length) {
        if (!this.factura.serie_document) {
          const last = newVal[newVal.length - 1];
          this.serieObj = last;
        }

        if (!this.factura.nr_document) {
          if (this.initialNumar) {
            this.factura.nr_document = String(this.initialNumar);
          } else if (this.factura.serie_document_obj?.last_nr) {
            const next = Number(this.factura.serie_document_obj.last_nr) + 1;
            if (!Number.isNaN(next)) {
              this.factura.nr_document = String(next);
            }
          }
        }
      }
    },
    coteTva() {
      this.hydrateAllProduseRefs();
    },
    planConturi() {
      this.hydrateAllProduseRefs();
    },
    produse: {
      deep: true,
      handler() {
        this.hydrateAllProduseRefs();
      }
    },
  }
}
</script>

<style scoped>
.adauga-factura-intrare-vertical {
  min-width: 320px;
}

.client-multiselect .multiselect__tags {
  border-radius: 0.475rem;
}

.multiselect {
  min-width: 0;
}


.date-picker-btn {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  padding: 0.25rem 0.4rem;
}

/* =====================
   Vue-Multiselect tuning (Bootstrap-like, theme-safe)
   ===================== */
:deep(.multiselect) {
  min-height: 38px;
  padding: 0;
}

:deep(.multiselect__tags) {
  min-height: 38px;
  border-radius: 0.475rem;
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background-color: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border: 1px solid var(--bs-border-color, #e4e6ef) !important;
}

:deep(.multiselect__single) {
  line-height: 1.5;
  padding: 0;
  margin: 0;
  background: transparent !important;
  color: var(--bs-body-color) !important;
}

:deep(.multiselect__placeholder) {
  margin: 0;
  color: var(--bs-secondary-color, rgba(0, 0, 0, .55)) !important;
}

:deep(.multiselect__input) {
  background: transparent !important;
  color: var(--bs-body-color) !important;
  caret-color: var(--bs-primary, #3e97ff) !important;
}

:deep(.multiselect__content-wrapper) {
  z-index: 999999 !important;
  background-color: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border: 1px solid var(--bs-border-color, #e4e6ef) !important;
}

:deep(.multiselect__option) {
  padding: 6px 8px;
}

:deep(.multiselect__option--selected) {
  background: rgba(var(--bs-primary-rgb), 0.12) !important;
  color: inherit !important;
}

:deep(.multiselect__option--highlight),
:deep(.multiselect__option--selected.multiselect__option--highlight) {
  background: var(--bs-primary, #3e97ff) !important;
  color: var(--bs-primary-inverse, #fff) !important;
}

/* =====================
   Furnizor field (ellipsis + correct alignment)
   ===================== */
.furnizor-multiselect {
  width: 100%;
}

.furnizor-multiselect :deep(.multiselect__single),
.furnizor-multiselect :deep(.multiselect__single span) {
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Stil pentru Cont Credit si UM (scris mic, wrap text) */
.small-text-multiselect :deep(.multiselect__single),
.small-text-multiselect :deep(.multiselect__option) {
  font-size: 0.8rem !important;
  white-space: normal !important;
  line-height: 1.25 !important;
}

/* Keep dropdown above cards/modals */
.furnizor-multiselect :deep(.multiselect__content-wrapper) {
  z-index: 999999 !important;
}

/* Dark theme fine-tune (fallback) */
[data-bs-theme="dark"] :deep(.multiselect__tags),
[data-bs-theme="dark"] :deep(.multiselect__content-wrapper) {
  background-color: #1e1e2d !important;
  border-color: #2b2b40 !important;
}

[data-bs-theme="dark"] :deep(.multiselect__placeholder) {
  color: rgba(225, 227, 234, 0.55) !important;
}
</style>
